import { render, staticRenderFns } from "./userList.vue?vue&type=template&id=5975c614&scoped=true&"
import script from "./userList.vue?vue&type=script&lang=ts&"
export * from "./userList.vue?vue&type=script&lang=ts&"
import style0 from "./userList.vue?vue&type=style&index=0&id=5975c614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5975c614",
  null
  
)

export default component.exports